import React, { useState } from 'react';
import JogadorToggle from './JogadorToggle';
import ProgressBar from './ProgressBar';
import { dispararGol } from '../utils/confetti';
import './PaisDropdown.css';

const PaisDropdown = ({ pais, onToggleJogador, defaultExpanded = false }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const jogadores = Object.entries(pais.jogadores).sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }));
  const obtidas = jogadores.filter(([, j]) => j.obtida).length;
  const total = pais.totalFigurinhas;
  const theme = pais.theme || 'default';

  const handleToggle = (sigla, key) => {
    const jogador = pais.jogadores[key];
    const eraObtida = jogador.obtida;
    onToggleJogador(sigla, key);
    // Dispara confete se esta foi a última figurinha (completou o time)
    if (!eraObtida && obtidas + 1 === total) {
      dispararGol();
    }
  };

  return (
    <div className={`pais-dropdown theme-${theme}`}>
      <button
        className="pais-header"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
      >
        <span className="pais-flag">{pais.flag}</span>
        <span className="pais-nome">{pais.nome}</span>
        <span className="pais-contador">{obtidas}/{total}</span>
        <span className={`pais-chevron ${expanded ? 'open' : ''}`}>›</span>
      </button>

      {expanded && (
        <div className="pais-progress-wrap">
          <ProgressBar obtidas={obtidas} total={total} size="small" showLabel={false} showMarkers={false} />
        </div>
      )}

      <div className={`pais-jogadores ${expanded ? 'open' : ''}`}>
        {jogadores.map(([key, jogador]) => (
          <JogadorToggle
            key={key}
            jogadorKey={key}
            nome={jogador.nome}
            obtida={jogador.obtida}
            onToggle={(k) => handleToggle(pais.sigla, k)}
          />
        ))}
      </div>
    </div>
  );
};

export default PaisDropdown;
